import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, notification } from "antd";
import { FiArrowLeft } from "react-icons/fi";
import JsonFormatter from "react-json-formatter";
import config from "../../config";
import serviceHome from "../../services/home";
import { removeStorageWhenLogout } from "../../config/helper";

const ModalHistoryLog = ({ openModal, onClose = () => {} }) => {
	const navigate = useNavigate();

	const [theFullChatHistory, setTheFullChatHistory] = useState("");

	const handleGetFullChatHistory = async () => {
		const getUserDataFromStorage = localStorage.getItem("userData");
		const response = await serviceHome.getFullChatHistory(
			`?userName=${getUserDataFromStorage}`
		);

		if (response.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				navigate("/signin");
			}, config.timeout);
		}
		if (response.httpStatus === 404) {
			setTheFullChatHistory("You don't have any chat history.");
		}
		if (response.httpStatus === 200) {
			setTheFullChatHistory(
				response.data || "You don't have any chat history."
			);
		}
	};

	useEffect(() => {
		handleGetFullChatHistory();
	}, []);

	return (
		<Modal
			footer={null}
			className="profile-modal"
			open={openModal}
			onCancel={() =>
				onClose({
					fullChatHistoryShow: false,
					popupShow: true,
				})
			}
			destroyOnClose
		>
			<div className="top-section">
				<div className="user-profile">
					<Button
						className="user-profile-icon"
						icon={<FiArrowLeft size={24} />}
						onClick={() =>
							onClose({
								fullChatHistoryShow: false,
								popupShow: true,
							})
						}
					/>
					Chat History Log
				</div>
				<div className="prompt-wrapper-with-beautify">
					{theFullChatHistory?.split("\n").map((content, key) => {
						let newText = content;
						if (content.includes('{"messages":')) {
							newText = (
								<JsonFormatter json={content} tabWith={4} />
							);
						}

						return <div key={key}>{newText}</div>;
					})}
				</div>
			</div>
		</Modal>
	);
};

export default ModalHistoryLog;
